export const inventoryFieldKeyPrefix = 'inventory'

export const inventoryFieldKeys = {
  csvImport: 'inventory.csv_import',
  csvExport: 'inventory.csv_export',
  productLocation: 'inventory.product_location',
  exportDetails: 'inventory.export_details',
  appliedToAllVariants: 'inventory.variant.applied_to_all_variants',
  variantCountry: 'inventory.variant.country',
  variantHsCode: 'inventory.variant.hs_code',
  variantWeight: 'inventory.variant.weight',
  variantWeightUnit: 'inventory.variant.weight_unit',
  variantUnitCost: 'inventory.variant.unit_cost',
  variantCustomsDescription: 'inventory.variant.customs_description',
}

export const variantFieldLabels = {
  [inventoryFieldKeys.variantCountry]: 'País de origen',
  [inventoryFieldKeys.variantHsCode]: 'HS Code',
  [inventoryFieldKeys.variantWeight]: 'Peso',
  [inventoryFieldKeys.variantWeightUnit]: 'Unidad',
  [inventoryFieldKeys.variantUnitCost]: 'Coste unitario',
  [inventoryFieldKeys.variantCustomsDescription]: 'Descripción para aduanas',
}

export const csvImportFieldLabels = {
  total_rows: 'Filas totales',
  processed_rows: 'Productos actualizados',
  error_rows: 'Errores encontrados',
}
